import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCityFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M18.971 7.424a.75.75 0 0 1-1.5 0c0-.414.336-.755.75-.755s.75.33.75.744zm-.75 5.233a.745.745 0 0 1-.75-.744v-.01a.75.75 0 0 1 1.5 0 .755.755 0 0 1-.75.754m.75 3.734a.75.75 0 0 1-1.5 0c0-.414.336-.756.75-.756s.75.331.75.745zm-3.529-8.967a.75.75 0 0 1-1.5 0c0-.414.336-.755.75-.755s.75.33.75.744zm3.592-4.434h-5.223a2.625 2.625 0 0 0-2.624 2.62v2.013a.3.3 0 0 0 .113.234l3.719 2.971a2.97 2.97 0 0 1 1.145 2.296v5.315a3.54 3.54 0 0 1-.569 1.91c-.143.223.004.551.268.551h3.171a2.64 2.64 0 0 0 2.638-2.64V5.63a2.64 2.64 0 0 0-2.638-2.64"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m14.051 11.61-3.983-3.183a2.426 2.426 0 0 0-3.009.004L3.111 11.61a1.94 1.94 0 0 0-.783 1.55v5.273a2.6 2.6 0 0 0 2.6 2.577h2.889q.006-.001.006-.008V16.72a.75.75 0 0 1 1.5 0v4.282q0 .008.006.008h2.907c.683 0 1.326-.263 1.812-.742a2.58 2.58 0 0 0 .773-1.835V13.14a1.98 1.98 0 0 0-.77-1.531"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCityFilled);
export default ForwardRef;
